import React, { useMemo } from 'react'
import generateBillingDetails from '../../functions/generateSoa/generateBillingDetails'
//import './index.css'
import { formatAmount } from 'utils/exportUtils'

//for syzygy

const BillingDetailsTable = ({ data = {} }) => {
    let newBillingDetails = generateBillingDetails(data)
    // Columns based on provided payroll data structure

    return (
        <table id='billing_details_table' style={{ borderCollapse: 'collapse', fontSize: '0.8rem' }}>
            <tbody>
                <tr>
                    <td style={{ border: '2px solid black', borderRight: 'none', borderBottom: 'none', textAlign: 'left', padding: '2px' }}>Gross Billing </td>
                    <td style={{ border: '2px solid black', borderLeft: 'none', borderBottom: 'none', textAlign: 'right', padding: '2px' }}>{formatAmount(newBillingDetails.gross_billing)}</td>
                </tr>
                <tr>
                    <td style={{ border: '2px solid black', borderRight: 'none', borderTop: 'none', textAlign: 'left', padding: '2px' }}>Administrative Cost</td>
                    <td style={{ border: '2px solid black', borderLeft: 'none', borderTop: 'none', textAlign: 'right', padding: '2px' }}>{formatAmount(newBillingDetails.admin_cost)}</td>
                </tr>
                 <tr>
                    <td style={{ border: '2px solid black', borderRight: 'none', borderTop: 'none', textAlign: 'left', padding: '2px' }}>Rebate</td>
                    <td style={{ border: '2px solid black', borderLeft: 'none', borderTop: 'none', textAlign: 'right', padding: '2px' }}>{formatAmount(newBillingDetails.rebate)}</td>
                </tr>
                <tr>
                    <td style={{ border: '2px solid black', borderBottom: 'none', borderRight: 'none', textAlign: 'left', padding: '2px' }}><strong>Sum Billing </strong></td>
                    <td style={{ border: 'none', textAlign: 'right', borderRight: '2px solid black', padding: '2px', borderTop: '2px solid black' }}><strong>{formatAmount(newBillingDetails.sum_billing)}</strong></td>
                </tr>
                <tr>
                    <td style={{ textAlign: 'left', border: '2px solid black', borderBottom: 'none', borderRight: 'none', borderTop: 'none', padding: '2px' }}>Vat (12 %)</td>
                    <td style={{ border: 'none', textAlign: 'right', borderRight: '2px solid black', padding: '2px' }}>{formatAmount(newBillingDetails.vat)}</td>
                </tr>
                <tr>
                    <td style={{ textAlign: 'left', border: '2px solid black', borderRight: 'none', borderTop: 'none', padding: '2px' }}>Wtx(2%)</td>
                    <td style={{ textAlign: 'right', border: '2px solid black', borderLeft: 'none', borderTop: 'none', padding: '2px', borderBottom: '2px solid black' }}>{formatAmount(newBillingDetails.withholding_tax)}</td>
                </tr>
                <tr style={{ fontWeight: 'bold' }}>
                    <td style={{ border: 'none', textAlign: 'left', border: '2px solid black', borderBottom: 'none', borderRight: 'none', fontWeight: 'bold', padding: '2px' }}>Total Billing</td>
                    <td style={{ borderRight: '2px solid black', textAlign: 'right', padding: '2px', borderTop: '2px solid black' }}>{formatAmount(newBillingDetails.total_billing)}</td>
                </tr>
                <tr>
                    <td style={{ borderLeft: '2px solid black', textAlign: 'left', padding: '2px' }}>Less: Salary Deduction</td>
                    <td style={{ borderRight: '2px solid black', textAlign: 'right', padding: '2px' }}>{formatAmount(newBillingDetails.salary_deduction)}</td>
                </tr>
                <tr>
                    <td style={{ borderLeft: '2px solid black', textAlign: 'left', padding: '2px' }}>Less: Meal Allowance</td>
                    <td style={{ borderRight: '2px solid black', textAlign: 'right', padding: '2px' }}>{formatAmount(newBillingDetails.meal_allowance)}</td>
                </tr>
                <tr style={{ backgroundColor: 'yellow', fontWeight: 'bold' }}>
                    <td style={{ borderLeft: '2px solid black', textAlign: 'left', borderBottom: '2px solid black', padding: '2px' }}>Net Billing</td>
                    <td style={{ borderRight: '2px solid black', textAlign: 'right', borderBottom: '2px solid black', padding: '2px' }}>{formatAmount(newBillingDetails.net_billing)}</td>
                </tr>
            </tbody>
        </table>
    )
    return <></>

}

export default BillingDetailsTable